import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';
import { processDataCollection } from '../../../../actions/application.js';

class DataCollectionAnalysisTool extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(datacollection) {
        this.props.processDataCollection(datacollection);
    }

    getToolDescription(){
        return this.props.datacollection.imagePrefix + " (" + this.props.datacollection.numberOfImages + " images )";
    }
    render() {
        var _this = this;
        if (this.props.configuration.dataAnalysis.enabled) {
            var toolDescription = this.getToolDescription();
            if (this.props.jobs.datacollectionJobTypes) {
                return <ButtonToolbar>
                    {Object.keys(this.props.jobs.datacollectionJobTypes).map(function (key) {
                        return (
                            <ButtonGroup>
                                <Link disabled target="_blank" to={"/analysis/" + key + "?datacollectionid=" + _this.props.datacollection.dataCollectionId + "&description=" + _this.getToolDescription() }>
                                    <Button onClick={()=>_this.handleClick(_this.props.datacollection)} bsStyle="primary">{key}</Button>
                                </Link>
                            </ButtonGroup>);
                    })}
                </ButtonToolbar>
            }
        }
        return null;
    }
}


function mapStateToProps(state) {
    return {
        jobs: state.jobs,
        configuration: state.configuration
    };
}

function mapDispatchToProps(dispatch) {
    return {         
        processDataCollection : (dataCollection) => dispatch(processDataCollection(dataCollection)),                            
      };
}



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DataCollectionAnalysisTool);



// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/DataCollectionListDataCollectionGroup/DataCollectionAnalysisTool.js